module.exports = __webpack_public_path__ + "media/images/users/taikuzuwari-0ddafb39930e673d7521ffa2516af214.png";